import type { ProfileInDbWithApplications, ResponseProfileWithApplications } from "@profile-service-types/index.ts";
import type { UseQueryOptions } from "@tanstack/vue-query";
import { useQuery } from "@tanstack/vue-query";
import type { Ref } from "vue";
import { computed } from "vue";
import profileService from "@/services/profile";

interface Args<TData = ProfileInDbWithApplications> {
  id: Ref<string>;
  useQueryOptions?: Partial<UseQueryOptions<ProfileInDbWithApplications, Error, TData>>;
}

export const getQueryKey = (id: Ref<string>) => ["getProfileDetails", id];

export const useGetProfileDetails = <TData = ProfileInDbWithApplications>({ id, useQueryOptions }: Args<TData>) => {
  const getProfileDetails = (): Promise<ProfileInDbWithApplications> =>
    profileService.getProfile(id.value).then((profile: { data: ResponseProfileWithApplications }) => {
      return profile?.data.data || {};
    });

  return useQuery<ProfileInDbWithApplications, Error, TData>({
    queryKey: computed(() => getQueryKey(id)),
    queryFn: getProfileDetails,
    ...useQueryOptions,
  });
};
